<template>
  <div class="container">
    <div class="box">
      <div class="title"><span id="payTitle">水费收款凭证</span></div>
      <div class="date">打印日期: {{ printDate }}</div>
      <div class="tableStyle">
          <table border="2">
          <thead>
            <tr>
              <th width="55">序号</th>
              <th>商铺名称</th>
              <th width="120">商铺编号</th>
              <th width="100">支付方式</th>
              <th width="90">数量(次)</th>
              <th width="150">收款日期</th>
              <th width="80" v-if="openServiceFee">水费</th>
              <th width="100" v-if="openServiceFee">{{serviceFeeColumnName}}</th>
              <th width="120">支付金额(元)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.lesseeName }}</td>
              <td>{{ item.lesseeCode }}</td>
              <td>{{ item.payType }}</td>
              <td>{{ item.number }}</td>
              <td>{{ item.payDate }}</td>
              <td v-if="openServiceFee">{{ item.fee }}</td>
              <td v-if="openServiceFee">{{ item.serviceFee }}</td>
              <td>{{ item.money }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="total">
        <el-row :gutter="20" class="totalRow">
          <el-col :span="8">
            合计（大写）：<span> {{ totalCapitalMoney }}</span>
          </el-col>
          <el-col :span="8">
            合计（小写）：<span> {{ totalMoney }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8"> 部门：<span> </span> </el-col>
          <el-col :span="8"> 经办人：<span> </span> </el-col>
          <el-col :span="8"> 审核人：<span> </span> </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import print from 'print-js';
import { getBatchPrintData } from '../../api/water/sellWaterRecord';
export default {
  data() {
    return {
      tableData: [],
      printDate: '',
      totalMoney: 0,
      totalCapitalMoney: '',
      serviceFeeColumnName: '',
      openServiceFee: false
    };
  },
  created() {
    let specificDate = new Date(2025, 10, 1, 0, 0, 0);
    let now = new Date();
    if(now.getTime() > specificDate.getTime()){
      this.openServiceFee = true;
    }
    this.serviceFeeColumnName = this.$route.query.serviceFeeColumnName;
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      // this.getNowTime();
      await this.getParams();
      window.print();
    },
    //显示当前时间
    getNowTime() {
      let now = new Date(),
        year = now.getFullYear(), //得到年份
        month = now.getMonth() + 1, //得到月份
        day = now.getDate(); //得到日期
      this.nowDate = year + '年' + month + '月' + day + '日';
    },
    async getParams() {
      let orderNos = JSON.parse(this.$route.query.multipleSelection);
      const res = await getBatchPrintData(orderNos).then();

      this.printDate = res.data.printDate;
      this.tableData = res.data.bodyList;
      this.totalMoney = res.data.totalMoney;
      this.totalCapitalMoney = res.data.totalCapitalMoney;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
/deep/ .el-table .cell {
  color: #000 !important;
  font-size: 16px;
}
.box {
  width: 1000px;
  min-height: 450px;
  padding: 30px 50px;
  background-color: #fff;
  box-sizing: border-box;
  .title {
    width: 100%;
    text-align: center;
    /deep/ span {
      font-weight: bold;
      letter-spacing: 5px;
      color: #000;
      font-size: 32px;
      display: inline-block;
      padding: 10px 20px;
      border-bottom: 3px double #000;
    }
  }
  .date {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: right;
    color: #000;
    padding-right: 20px;
  }
  .total {
    // margin-top: 20px;
    .el-row {
      line-height: 40px;
    }
  }
}
.btns {
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.el-table {
  width: fit-content;
}
.totalRow {
  border: 2px solid #000;
  border-top: 0;
}
/deep/ .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media print {
  @page {
    size: auto;
    margin: 8mm;
  }
  tbody {
    /* tables don't split across pages if possible. */
    page-break-inside: avoid;
  }
  .footer {
    page-break-after: always;
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  th{
    height: 42px;
  }
  td{
    height: 40px;
    text-align: center;
  }
}
</style>
